import { createSvgIcon } from '@mui/material';

const XsIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20.952"
    height="20.245"
    viewBox="0 0 20.952 20.245"
  >
    <g id="Group_3008" data-name="Group 3008" transform="translate(-929.029 -512.903)">
      <path
        id="Path_2809"
        data-name="Path 2809"
        d="M930,535h1.1l5.3,5.3-6.316,6.485"
        transform="translate(0 -14.698)"
        fill="none"
        stroke="#85C440"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="1.5"
      />
      <path
        id="Path_2810"
        data-name="Path 2810"
        d="M976.377,535h-1.1l-5.3,5.3,6.47,6.47"
        transform="translate(-27.522 -14.698)"
        fill="none"
        stroke="#85C440"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="1.5"
      />
      <line
        id="Line_713"
        data-name="Line 713"
        x2="6.045"
        transform="translate(936.405 525.603)"
        fill="none"
        stroke="#85C440"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="1.5"
      />
      <path
        id="Path_2811"
        data-name="Path 2811"
        d="M950.714,525.4v-4.537a.808.808,0,0,0-.808-.808H936.2a.808.808,0,0,0-.808.808V525.3"
        transform="translate(-3.712 -4.411)"
        fill="none"
        stroke="#85C440"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="1.5"
      />
      <path
        id="Path_2813"
        data-name="Path 2813"
        d="M955,515.616l-1.448-1.345a2.368,2.368,0,0,0-1.608-.618h-2.793a2.368,2.368,0,0,0-1.608.618l-1.5,1.395"
        transform="translate(-11.04)"
        fill="none"
        stroke="#85C440"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="1.5"
      />
      <path
        id="Path_2814"
        data-name="Path 2814"
        d="M931.644,529.4,930,530.923h0v11.836h19V530.925l-.019-.019-1.965-1.825"
        transform="translate(0 -10.623)"
        fill="none"
        stroke="#85C440"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="1.5"
      />
      <line
        id="Line_714"
        data-name="Line 714"
        x2="6.045"
        transform="translate(936.405 521.399)"
        fill="none"
        stroke="#85C440"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="1.5"
      />
      <line
        id="Line_716"
        data-name="Line 716"
        x2="6.045"
        transform="translate(936.405 518.64)"
        fill="none"
        stroke="#85C440"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="1.5"
      />
    </g>
  </svg>,
  'XsIcon',
);

export default XsIcon;
